import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SkyGraphic from './SkyGraphic';

interface CtaCardProps {
  title: string;
  subtitle?: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

const CtaCard = ({ title, subtitle, primaryLabel, primaryTo, secondaryLabel, secondaryTo }: CtaCardProps) => {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16 md:py-20">
      <div className="relative overflow-hidden bg-primary-950 border-l-4 border-gold-500 px-8 py-14 md:px-16 md:py-16">
        <SkyGraphic variant="flightpath" tone="dark" className="opacity-40" />
        <div className="relative max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500 mb-4">Sky View GmbH</div>
          <h2 className="text-2xl md:text-3xl font-serif font-medium text-white leading-tight mb-4">{title}</h2>
          {subtitle && <p className="text-primary-200 text-base md:text-lg leading-relaxed mb-8">{subtitle}</p>}
          <div className="flex flex-wrap items-center gap-4">
            <Link
              to={primaryTo}
              className="inline-flex items-center gap-2 bg-gold-500 hover:bg-gold-600 text-primary-950 font-semibold px-6 py-3.5 transition-colors"
            >
              {primaryLabel}
              <ArrowRight className="w-4 h-4" />
            </Link>
            {secondaryLabel && secondaryTo && (
              <Link
                to={secondaryTo}
                className="inline-flex items-center gap-2 border border-white/30 hover:border-gold-500 hover:text-gold-400 text-white font-medium px-6 py-3.5 transition-colors"
              >
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaCard;
